<template>
    <div class="scrollable only-y" v-loading="loadingDetail">
        <div style="float:right">
            <!-- <el-button type="primary" @click="dialogAddAdditionalServiceUser=true">+ Add Additional Service</el-button> -->
            <el-button type="primary" @click="dialogAddServiceUser=true">+ Add Service User</el-button>
        </div>
        <el-dialog title="Add Additional Service" :visible.sync="dialogAddAdditionalServiceUser">
            <el-form>
                <el-form-item>
                    <el-input type="text" v-model="form.serviceName" placeholder="Insert Additional Service Name"></el-input>
                </el-form-item>
                <el-button :loading="loadingBtnAddServiceAdditional" type="primary" @click="addServiceAdditionalUser">Save</el-button>
                <el-button type="danger" @click="dialogAddAdditionalServiceUser=false">Close</el-button>
            </el-form>
        </el-dialog>
        <el-dialog title="Add Service User" :visible.sync="dialogAddServiceUser">
            <el-form>
                <el-form-item>
                    <el-select v-model="selectedService" placeholder="Select service" :default-first-option="true">
                        <el-option
                        v-for="(item, index) in availableService"
                        :key="index"
                        :label="item.as"
                        :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input type="textarea" rows="3" v-model="form_assign.token_whatsapp" placeholder="Insert Credentials Token"></el-input>
                </el-form-item> -->
                <el-form-item v-if="selectedService != 'auditrail'">
                    <!-- <el-input v-model="form_assign.phone_wa" placeholder="Insert Credentials Phone Number"></el-input> -->
                    <el-select v-model="form_assign.phone_wa" placeholder="Select service" :default-first-option="true">
                        <el-option
                        v-for="(item, index) in availableNumber"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-button :loading="loadingBtnAddService" type="primary" @click="addServiceUser">Save</el-button>
                <el-button type="danger" @click="dialogAddServiceUser=false">Close</el-button>
            </el-form>
        </el-dialog>
        <!-- {{businessId}} -->
        <el-col>
            <el-form ref="form" label-width="240px" label-position="left" v-loading="loadingUpdate">
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" label="Business Id">
                        <el-input v-model="bussinessId" :disabled="disabled" style="width:250px;"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.created_at')">
                        <el-tag type="success">{{ consumen.created_at }}</el-tag>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.type')">
                        <el-tag type="success" v-if="consumen.customer_type == 2">Business</el-tag>
                        <el-tag type="default" v-else>Personal</el-tag>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.status')">
                        <el-tag type="danger" v-if="consumen.status_upgrade == 3">Rejected</el-tag>
                        <el-tag type="success" v-if="consumen.status_upgrade == 2"><i class="mdi mdi-approval"></i> Approve</el-tag>
                        <el-tag type="warning" v-if="consumen.status_upgrade == 1">Pending Request</el-tag>
                        <el-tag type="default" v-if="consumen.status_upgrade == 0">-</el-tag>
                        <el-tag type="default" v-if="consumen.status_upgrade == '-'">-</el-tag>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.name')">
                        <el-input v-model="consumen.customer_name" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.brand')">
                        <el-input v-model="consumen.customer_brand" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.npwp')">
                        <el-input v-model="consumen.customer_npwp" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.siup')">
                        <el-input v-model="consumen.customer_siup" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.skdp')">
                        <el-input v-model="consumen.customer_skdp" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.tdp')">
                        <el-input v-model="consumen.customer_tdp" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.pic_name')">
                        <el-input v-model="consumen.customer_pic_name" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.pic_email')">
                        <el-input v-model="consumen.customer_pic_email" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.pic_phone')">
                        <el-input v-model="consumen.customer_pic_phone" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.pic_tech_name')">
                        <el-input v-model="consumen.customer_tech_pic_name" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.pic_tech_email')">
                        <el-input v-model="consumen.customer_tech_pic_email" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.pic_tech_phone')">
                        <el-input v-model="consumen.customer_tech_pic_phone" :disabled="disabled"/>
                    </el-form-item>
                </el-col>
                <el-col v-if="consumen.auditrail == 1" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.auditrail')">
                        <!-- <el-input v-model="consumen.auditrail" disabled /> -->
                        <div>
                            <el-tag type="success" >Subscribed</el-tag>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item style="font-weight: bold" :label="$t('consumen.temp_amount')">
                        <el-input v-model="totalTemplate" disabled style="width: 200px"/>
                        <el-button class="ml-10" type="info" @click="synchronize()" :loading="loadingSync">
                            <i class="mdi mdi-sync"></i> Synchronize
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
        </el-col>
        <div class="clearfix" style="float:left;">
            <el-button v-if="consumen.status_upgrade == '1'" @click="dialogConfirm = true" type="success">Approve Request</el-button>
            <el-button v-if="consumen.status_upgrade == '1'" @click="dialogConfirm = true" type="danger">Reject Request</el-button>
            <el-button v-if="consumen.status_upgrade == '2'" @click="dialogConfirmRevoke = true" type="success">Revoke</el-button>
            <el-button @click="editConsumen">{{disabled? "Edit" : "Cancel"}}</el-button>
            <el-button v-if="!disabled" @click="updateCustomer" type="primary" v-loading="loadingBtn">Save</el-button>
        </div>
        <el-button @click="$router.push('/consumen')" style="float: right; margin-bottom: 20px;" class="button">Back</el-button>

        <div>
            <el-dialog title="Confirm" :visible.sync="dialogConfirmRevoke" width="40%" v-if="consumen.status_upgrade == '2'">
                <span>Approve this account to be a personal account?</span><br><br>
                <el-form label-position="top" status-icon :rules="rulesForm" ref="form" label-width="200px" :model="form">
                    <el-form-item prop="pic_email">
                        <el-input v-model="form.pic_email" placeholder="Please input user email to be PIC for this account"/>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="revokeStatusAccount" type="primary" :loading="loadingRevoke">Confirm</el-button>
                    <el-button @click="dialogConfirmRevoke = false">Cancel</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Confirm" :visible.sync="dialogConfirm" width="40%" v-else>
                <span>Approve this account to be a bussiness account?</span><br><br>
                <el-form label-position="top" status-icon :rules="rulesForm" ref="form" label-width="200px" :model="form">
                    <el-form-item prop="pic_email">
                        <el-input v-model="form.pic_email" placeholder="Please input user email to be PIC for this account"/>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="approveUpgradeAccount" type="primary" :loading="loadingApprove">Confirm</el-button>
                    <el-button @click="dialogConfirm = false">Cancel</el-button>
                </span>
            </el-dialog>
		</div>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')

export default {
    props: {
        initConsumen: Object,
        initLoading: {
            type: Boolean,
            default: true
        },
    },
    name: "Detail",
    data() {
        var checkHasValue = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("Please fill PIC email for this account"));
            } else{
                callback()
            }
        }
        return {
            availableNumber:[],
            consumen: this.initConsumen,
            loadingConsumen: false,
            loadingBusinessId: false,
            loadingDetail: true,
            initBusinessId: '',
            bussinessId: '-',
            totalTemplate: 0,
            dialogAddAdditionalServiceUser: false,
            loadingBtnAddServiceAdditional: false,
            loadingBtn: false,
            form: {
                serviceName: ""
            },
            listProduct: [],
            selectedProductAssigned: '',
            loadingBtnAddService: false,
            disabled: true,
            loadingBtn:false,
            formLabelWidth: '200px',
            whoIsPic: null,
            loadingApprove: false,
            loadingRevoke: false,
            loadingUpdate: false,
            dialogConfirm: false,
            dialogConfirmRevoke: false,
            dialogAddServiceUser: false,
            dialogEdit: false,
            showTooltip: false,
            form: {
                pic_email: "",
                approve: "approve"
            },
            rulesForm: {
                pic_email: [
                    { validator: checkHasValue, trigger: 'blur' },
                    { type: 'email', trigger: 'blur', message: "Please input a valid email format" }
                ]
            },
            form_assign: {
                phone_wa: "",
                token_whatsapp: "",
                limit:''
            },
            availableService: [
                { name: 'whatsapp', as: 'Whatsapp' },
                { name: 'helpdesk', as: 'Helpdesk' },
                // { name: 'telegram', as: 'Telegram' },
                // { name: 'auditrail', as: 'Auditrail'}
            ],
            selectedService: "whatsapp",
            loadingSync: false
        }
    },
    watch: {
        initConsumen: function() {
            this.consumen = JSON.parse(JSON.stringify(this.initConsumen))
        },
        initLoading: function() {
            if (!this.initLoading && !this.loadingConsumen && !this.loadingBusinessId) 
                this.loadingDetail = false
            else this.loadingDetail = true
        },
        loadingConsumen: function() {
            if (!this.initLoading && !this.loadingConsumen && !this.loadingBusinessId) 
                this.loadingDetail = false
            else this.loadingDetail = true
        },
        loadingBusinessId: function() {
            if (!this.initLoading && !this.loadingConsumen && !this.loadingBusinessId) 
                this.loadingDetail = false
            else this.loadingDetail = true
        }
    },
    created(){
        this.getBusinessId()
    },
    mounted(){
        this.getBusinessId()
        this.numberWaCon()
    },
    methods: {
        async numberWaCon(page = 1){
			this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'service?page=' + page,
				method:'post',
                params:{
                    customer_id: this.$route.params.consumen
                }
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.availableNumber = response.data.data
                    // console.log("availableNumber",this.availableNumber)
					
                    if (this.availableNumber.length != 0) {
                        this.availableNumber.map(el=>{
                            if (el.phone_number) {
                                if(el.phone_number.charAt(0) == 0){
                                    el.label = el.phone_number
                                    el.value = el.phone_number
                                } else if (el.phone_number.charAt(0) == 6 && el.phone_number.charAt(1) == 2){
                                    el.label = '0' + el.phone_number.substring(2)
                                    el.value = '0' + el.phone_number.substring(2)
                                } else {
                                    el.label = el.phone_number
                                    el.value = el.phone_number
                                }
                                // el.label = el.phone_number.charAt(0) == 0 ? el.phone_number : ('0' + el.phone_number.substring(2))
                                // el.value = el.phone_number.charAt(0) == 0 ? el.phone_number : ('0' + el.phone_number.substring(2))
                            }

                            return el
                        })
                    }
				}
				this.loadingConsumen = false
			}).catch(error => {
				this.loadingConsumen = false
            })
        },
        synchronize(){
            this.$swal({
              title: 'Are you sure to sync templates for this business?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, sure!',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(() => {
                this.loadingSync = true
                api({
                    url: config.baseApi+"consumen/sync-template/"+this.$route.params.consumen+"/"+this.bussinessId,
                    method: "get"
                }).then(response => {
                    // alert("success")
                    this.$swal(this.$t('success'), "Template successfully synced", "success").then(this.clear())
                    // console.log("sync process success with response ",response)
                    this.getBusinessId()
                    this.loadingSync = false
                }).catch(error => {
                    // alert("error")
                    this.$swal(this.$t('error'), 'Sorry, sync failed because it reached the limit of API requests to facebook. Please try again later.', "error").then(this.clear())
                    console.log("sync process error with response ",error)
                    this.loadingSync = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Syncronize canceled'
                });
                this.additionalServiceLoadingButton = false
            });
        },
        editConsumen(){
            if (!this.disabled) {
                this.bussinessId = this.initBusinessId
                this.consumen = JSON.parse(JSON.stringify(this.initConsumen))
            }
            this.disabled = !this.disabled
        },
        async approveUpgradeAccount(){
            this.loadingApprove = true
            this.showTooltip = false
            if(this.form.pic_email == "" || this.form.pic_email == null || this.form.action == "" || this.form.action == null){
                this.showTooltip = true
            }
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId + '/upgrade',
                method: 'post',
                data:{
                    email: this.form.pic_email,
                    action: this.form.approve
                }
            }).then(res => {
                // console.log('ec res',res.data.ec)
                // if(res.data.ec != 200){
                //     this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                //     this.dialogConfirm = false
                //     this.loadingApprove = false
                // } 
                // else 
                if(res.data.ec == 400){
                    this.$swal(this.$t('error'), 'User not in this company', "error").then(this.clear())
                    this.dialogConfirm = false
                    this.loadingApprove = false
                } else {
                    // console.log('response is',res.data.data)
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.dialogConfirm = false
                    this.detailConsumen()
                    this.loadingApprove = false
				}
            }).catch(err => {
                console.log('Failed :', err.message)
                // this.$swal(this.$t('error'), err.message, "error").then(this.clear())
                this.dialogConfirm = false
                this.loadingApprove = false
            })
        },

        async rejectStatusAccount(){
            this.showTooltip = false
            if(this.form.pic_email == "" || this.form.pic_email == null || this.form.token_whatsapp == "" || this.form.token_whatsapp == null){
                this.showTooltip = true
            }
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId + '/reject',
                method: 'post',
                data:{
                    email: this.form.pic_email,
                    action: this.form.approve
                }
            }).then(res => {
                
            }).catch(err => {
                
            })
        },

        async revokeStatusAccount(){
            this.showTooltip = false
            if(this.form.pic_email == "" || this.form.pic_email == null){
                this.showTooltip = true
            }
            this.loadingRevoke = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId + '/revoke_account',
                method: 'patch',
                data:{
                    email: this.form.pic_email,
                    action: 'revoke'
                }
            }).then(res => {
                // console.log('response is',res.data.data)
                this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                this.dialogConfirmRevoke = false
                this.loadingRevoke = false
                this.detailConsumen()
            }).catch(err => {
                console.log('error is',err.message)
                this.$swal(this.$t('error'), 'User not in this company', "error").then(this.clear())
                this.dialogConfirmRevoke = false
                this.loadingRevoke = false
            })
        },

        async detailConsumen(){
            // console.log("loading from fragment")
            this.loadingConsumen = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId,
                method: 'get'
            })
            .then(res => {
                this.consumen = res.data.data.consumen
                // console.log(res.data)
                this.consumen.created_at = moment(this.consumen.created_at).format("dddd, DD MMM YYYY HH:mm")
                // console.log(this.consumen)
            })
            .catch(err => {

            })
            this.loadingConsumen = false
        },
        async getBusinessId(){
            this.loadingBusinessId = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/businessId/' + custId,
                method: 'get'
            })
            .then(res => {
                if(res.data.ec == 200) {
                    // console.log("get bussiness id data",res.data.data)
                    this.initBusinessId = res.data.data.bussinessId == "" ? "-" : res.data.data.bussinessId
                    // console.log("init business id",this.initBusinessId)
                    this.bussinessId = this.initBusinessId
                    this.totalTemplate = res.data.data.total
                    // console.log("total template",this.totalTemplate)
                } /* else {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                } */
            })
            .catch(err => {
                console.log("Failed: ", err.message);
            })
            this.loadingBusinessId = false
        },
        async updateCustomer(){
            this.loadingBtn = true
            let custId = this.$route.params.consumen
            await api({
                url:config.baseApi+'consumen/'+custId+'/update',
                method:"patch",
                data:{
                    bussinessId: this.bussinessId,
                    customer_name: this.consumen.customer_name,
                    customer_brand: this.consumen.customer_brand,
                    customer_npwp: this.consumen.customer_npwp,
                    customer_siup: this.consumen.customer_siup,
                    customer_skdp: this.consumen.customer_skdp,
                    customer_tdp: this.consumen.customer_tdp,
                    customer_pic_name: this.consumen.customer_pic_name,
                    customer_pic_email: this.consumen.customer_pic_email,
                    customer_pic_phone: this.consumen.customer_pic_phone,
                    customer_tech_pic_name: this.consumen.customer_tech_pic_name,
                    customer_tech_pic_email: this.consumen.customer_tech_pic_email,
                    customer_tech_pic_phone: this.consumen.customer_tech_pic_phone
                }
            }).then(res => {
                if(res.data.ec!=200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                } else {
                    this.$swal(this.$t('success'), this.$t('success'), "success")
                    this.loadingUpdate = true
                    this.disabled = true
                    this.getBusinessId()
                }
            }).catch(err => {
                return err
            });
            this.loadingBtn = false
            this.loadingUpdate = false
        },

        async addServiceUser(){
            let custId = this.$route.params.consumen
            let apiURL = config.baseApi + 'consumen/' + custId
            // console.log("form_assign.phone_wa",this.form_assign.phone_wa)
            if(this.selectedService != 'auditrail' && _.isEmpty(this.form_assign.phone_wa)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

            if(this.selectedService == "helpdesk"){
                apiURL += '/addServiceHelpdesk'
            }
            if(this.selectedService == "whatsapp"){
                apiURL += '/addServiceUser'
            }

            let data = {
                    // "token_whatsapp":this.form_assign.token_whatsapp,
                    wa_phone:this.form_assign.phone_wa
                }
            
            if (this.selectedService == "auditrail") {
                data.name = this.selectedService
                delete data.wa_phone
                apiURL += '/addServiceAdditionalUser'
            }
            this.loadingBtnAddService = true
            await api({
                method:'post',
                url: apiURL,
                data: data
            }).then(res => {
                if(res.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                } else {
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.detailConsumen()
                    this.detailConsumenProduct()
                }
            }).catch(err => {
            })
            this.dialogAddServiceUser=false
            this.loadingBtnAddService = false
        },

        addServiceAdditionalUser(){
            if(_.isEmpty(this.form.serviceName)){
				this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
			}
            let custId = this.$route.params.consumen
			api({
				method:'post',
				url:config.baseApi+'consumen/'+custId+'/addServiceAdditionalUser',
				data:{
					"name":this.form.serviceName
				}
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.detailConsumenProduct()
				}
			}).catch(err => {
                return err
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
			})
			this.dialogAddAdditionalServiceUser=false
        },

        clear(){
            this.form.pic_email = ''
            this.form.approve = ''
            this.form_assign.token_whatsapp = ''
            this.form_assign.phone_wa = ''
    	}
    }
}
</script>
